<template>
    <div class="container">
        <PatientsListingFilters 
            :filters="params"
            :order-options="orderOptions"
            @change="onFilters" 
        />

        <div class="matrix-panel">
            <div class="table-layout table-patient table-maintenance">
                <TableHeader v-if="patients.length !== 0" :showDaysTillEndOfSubscription="showDaysTillEndOfSubscription" />

                <PatientsListingTableBody
                    ref="TableBody"
                    :phase="phase"
                    :freemium="freemium"
                    :params="params"
                    :freeze="freeze"
                    :deactivated="deactivated"
                    @fetched="onFetched"
                >
                    <PatientRow v-for="patient in patients" :key="patient.id" :class="{'patient-inactive': freeze || deactivated}" :patient="patient" :showDaysTillEndOfSubscription="showDaysTillEndOfSubscription" />
                </PatientsListingTableBody>
            </div>
        </div>

        <CoachDetailModal />
    </div>
</template>

<script>
import PatientRow from '@components/Doctors/PatientsMatrix/Sustain/PatientRow'
import TableHeader from '@components/Doctors/PatientsMatrix/Sustain/TableHeader'
import CoachDetailModal from '@components/Doctors/PatientsMatrix/CoachDetailModal'

import PatientsListing from '@components/PatientsMatrix/PatientsMatrix'

export default {
    components: {
        PatientRow,
        TableHeader,
        CoachDetailModal
    },
    extends: PatientsListing,
    props: {
        orderOptions: {
            type: Array,
            required: false,
            default() {
                return ['newest', 'oldest']
            }
        },
    },
    mounted() {
        $(function() {
            $('.item-maintenance').addClass('active')
        })
    }
}
</script>
